module.exports = __webpack_public_path__ + "44a014835cd7c0d2ba632b9163f61a4f.png";